import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
import * as echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  name: 'lineChart',
  props: ['lineChart', 'title'],
  data: function data() {
    return {
      image: ''
    };
  },
  methods: {
    initBarChart: function initBarChart(data, columnsData, index, resolve) {
      var _this = this;

      var seriesData = [];

      if (columnsData.length == 2) {
        var data1 = columnsData[0].data;
        var data2 = columnsData[1].data;
        columnsData.forEach(function (item, index) {
          seriesData.push({
            type: item.type,
            name: item.name,
            data: []
          });
        });

        for (var i = 0; i < data1.length; i++) {
          if (data1[i] > data2[i]) {
            seriesData[0].data.push({
              value: data1[i],
              label: {
                show: true,
                position: 'top',
                formatter: function formatter(params) {
                  return params.value + '%';
                }
              }
            });
            seriesData[1].data.push({
              value: data2[i],
              label: {
                show: true,
                position: 'bottom',
                formatter: function formatter(params) {
                  return params.value + '%';
                }
              }
            });
          } else {
            seriesData[0].data.push({
              value: data1[i],
              label: {
                show: true,
                position: 'bottom',
                formatter: function formatter(params) {
                  return params.value + '%';
                }
              }
            });
            seriesData[1].data.push({
              value: data2[i],
              label: {
                show: true,
                position: 'top',
                formatter: function formatter(params) {
                  return params.value + '%';
                }
              }
            });
          }
        }
      } else {
        seriesData = columnsData;
      }

      var xData = data.xData;
      var legendData = ['监测数量完成率', '数据有效率'];
      var option = {
        title: {
          text: "".concat(this.title),
          top: 'auto',
          x: 'center',
          textStyle: {
            fontSize: 18,
            color: 'black'
          }
        },
        // tooltip: {
        //   show: true,
        //   trigger: 'axis',
        //   // axisPointer: {
        //   //   type: 'shadow'
        //   // }
        // },
        legend: {
          data: legendData,
          bottom: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '7%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          axisTick: {
            show: false
          },
          data: xData,
          nameLocation: 'center'
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}%'
          }
        }],
        series: seriesData
      };
      var chart = this.$refs[this.lineChart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option, true);
      setTimeout(function () {
        _this.image = myChart.getDataURL();

        _this.$emit('lineChartIamge', _this.image, index);

        resolve('333');
      }, 1000);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};